module.exports = __webpack_public_path__ + "img/bhg.c8ec456d.png";